"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const users_service_1 = require("../../../shared/users/users.service");
let UserInfoComponent = class UserInfoComponent {
    constructor(usersService) {
        this.usersService = usersService;
        this.userName = '';
    }
    ngOnChanges(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!changes.userId)
                return;
            const user = this.usersService.getUserFromId(this.userId);
            if (!user)
                return;
            this.user = user;
            this.userName = `${user.first_name} ${user.last_name}`;
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], UserInfoComponent.prototype, "userId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], UserInfoComponent.prototype, "additionalInfo", void 0);
UserInfoComponent = __decorate([
    (0, core_1.Component)({
        selector: 'user-info',
        templateUrl: require('./user-info.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _a : Object])
], UserInfoComponent);
exports.default = UserInfoComponent;
